var __jsx = React.createElement;
import { cn } from '@lib/cn';
import facebookIntegrationManager from '@lib/data/managers/shared/integrations/implementations/facebook-integration-manager';
import { MuscleButton } from '@modules/shared/components/buttons';
import Icons from '@modules/icons';
import { useLocale, useTranslations } from 'next-intl';
import React, { useEffect } from 'react';
const SocialMediaAuth = _ref => {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;
  let {
    type,
    className,
    successCallback,
    loading,
    setLoading
  } = _ref;
  const t = useTranslations('Shared');
  const locale = useLocale();
  const divRef = React.useRef(null);
  const facebookAuth = ((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_FACEBOOK_AUTH) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : 'false') === 'true';
  const googleAuth = ((_process$env$NEXT_PUB2 = process.env.NEXT_PUBLIC_GOOGLE_AUTH) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : 'true') === 'true';
  useEffect(() => {
    if (!divRef.current) return;
    google.accounts.id.initialize({
      client_id: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '',
      context: type === 'login' ? 'signin' : 'signup',
      callback: async response => {
        await (successCallback === null || successCallback === void 0 ? void 0 : successCallback(response.credential, 'google'));
      }
    });
    google.accounts.id.renderButton(divRef.current, {
      theme: 'outline',
      size: 'large',
      locale: locale,
      text: type === 'login' ? 'signin' : 'signup_with',
      type: 'standard'
    });
  }, [locale, successCallback, type, divRef]);
  return __jsx(React.Fragment, null, __jsx("div", {
    className: cn("flex flex-col gap-2 items-center justify-center w-full", className)
  }, googleAuth && __jsx(MuscleButton, {
    variant: "outlineXL",
    isLoading: loading,
    disabled: loading,
    onClick: async () => {
      setLoading(true);
      try {
        if (!divRef.current) return;
        const button = divRef.current.querySelector('[role="button"]');
        if (!button) return;
        button.click();
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  }, __jsx(Icons.googleFilled, {
    size: 18
  }), type === 'login' ? t('Auth.SIGN_IN_WITH_GOOGLE') : t('Auth.SIGN_UP_WITH_GOOGLE')), facebookAuth && __jsx(MuscleButton, {
    variant: "outlineXL",
    disabled: loading,
    isLoading: loading,
    onClick: async () => {
      setLoading(true);
      try {
        if (await facebookIntegrationManager.isLogged()) {
          await facebookIntegrationManager.logout();
        }
        const {
          provider_token,
          provider_id
        } = await facebookIntegrationManager.login();
        await (successCallback === null || successCallback === void 0 ? void 0 : successCallback(provider_token, provider_id));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  }, __jsx(Icons.facebookFilled, {
    size: 18
  }), type === 'login' ? t('Auth.SIGN_IN_WITH_FACEBOOK') : t('Auth.SIGN_UP_WITH_FACEBOOK')), __jsx("div", {
    ref: divRef,
    id: "buttonDiv",
    className: "hidden"
  })));
};
export default SocialMediaAuth;